module.exports = __webpack_public_path__ + "assets/img/text-image-portrait.5aa1e17c.jpg";